import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatListModule } from '@angular/material/list';

import { A11yModule } from '@angular/cdk/a11y';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
//import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

/*import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';*/

@NgModule({
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatIconModule,
    CdkAccordionModule,
    ScrollingModule,
    MatListModule,
    A11yModule,
    CdkAccordionModule,
    MatButtonModule,
    MatStepperModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    ScrollingModule,
    MatStepperModule,
    MatExpansionModule,
    MatStepperModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    //MatDatepickerModule,
    MatInputModule,
    //NgxMatDatetimePickerModule,
    //NgxMatNativeDateModule,
    //NgxMatTimepickerModule
  ],

  exports: [
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatIconModule,
    CdkAccordionModule,
    ScrollingModule,
    MatListModule,
    A11yModule,
    CdkAccordionModule,
    MatButtonModule,
    MatStepperModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    ScrollingModule,
    MatStepperModule,
    MatExpansionModule,
    MatStepperModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    //MatDatepickerModule,
    MatInputModule,
    //NgxMatDatetimePickerModule,
    //NgxMatNativeDateModule,
    //NgxMatTimepickerModule
  ]
})
export class MaterialModule { }
